import type { Cart } from '@/modules/cart/domain/Cart';
import {
  EShippingMethod,
  EShippingSubType,
  EShippingType
} from '@/modules/cart/domain/Cart';

export const verifyAllGroupsArePickup = (cart: Cart) => {
  if (!cart?.deliveryInfo?.deliveryGroups?.length) return false;

  return cart?.deliveryInfo?.deliveryGroups?.every((group) => {
    const shippingMethod = group?.shippingOption?.shippingMethod;
    const shippingType = group?.shippingOption?.shippingType;
    const shippingSubType = group?.shippingOption?.shippingSubType;

    const isScheduled = shippingMethod === EShippingMethod.SCHEDULED;
    const isCollect = shippingType === EShippingType.COLLECT;
    const isInStore = shippingSubType === EShippingSubType.IN_STORE;
    const isCopec = shippingSubType === EShippingSubType.COPEC;

    return isCollect && isScheduled && (isInStore || isCopec);
  });
};

export default verifyAllGroupsArePickup;
